import { Expose, plainToClass } from 'class-transformer';
import BasketBillingMethod from './BasketBillingMethod';

export default class CreditCard {
  @Expose() name: string = '';
  @Expose() number: string = '';
  @Expose() cvv: string = '';
  @Expose() exp_month: number = 0;
  @Expose() exp_year: number = 0;
  @Expose() zip: string = '';
  @Expose() saveonfile: boolean = false;

  constructor(
    name: string,
    number: string,
    cvv: string,
    exp_month: number,
    exp_year: number,
    zip: string,
    saveonfile: boolean
  ) {
    this.name = name;
    this.number = number;
    this.cvv = cvv;
    this.exp_month = exp_month;
    this.exp_year = exp_year;
    this.zip = zip;
    this.saveonfile = saveonfile;
  }

  isFn = ((): boolean => {
    return true;
  })

  toBasketBillingMethod = ((): BasketBillingMethod => {
    let xp_year = this.exp_year < 2000 ? this.exp_year + 2000 : this.exp_year;

    const bbm = plainToClass(BasketBillingMethod, {
      billingmethod: 'creditcard',
      expiryyear: xp_year,
      expirymonth: this.exp_month,
      cardnumber: this.number,
      cardname: this.name,
      cvv: this.cvv,
      zip: this.zip,
      saveonfile: this.saveonfile,
    }, { excludeExtraneousValues: true });
    return bbm;
  })
}
